ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Board = require 'models/board'
Card = require 'models/card'
List = require 'models/list'
ModelLoader = require 'db/model-loader'
Organization = require 'models/organization'
Promise = require 'bluebird'
React = require 'react'
_ = require 'underscore'
t = require('views/internal/recup-with-helpers')('home')

{ TeamCardsDueSection } = require './presentational/team-cards-due-section'

module.exports = class TeamCardsDueContainer extends React.Component
  displayName: 'TeamCardsDueContainer'

  constructor: (props) ->
    super props

    @unresolvedPromises = new Set()
    @fetchDueDateCards = @fetchDueDateCards.bind(@)

    @state = {
      dueDateCards: []
    }

  componentDidMount: ->
    @cancelOnUnmount(new Promise((resolve) -> ModelLoader.waitFor('boardsData', resolve))).then =>
      @fetchDueDateCards().then (dueDateCards) =>
        @setState
          dueDateCards: dueDateCards
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e

  componentWillUnmount: ->
    @unresolvedPromises.forEach((promise) -> promise.cancel())

  cancelOnUnmount: (promise) =>
    promise.cancellable()
    @unresolvedPromises.add(promise)
    promise.then => @unresolvedPromises.delete(promise)

    return promise

  fetchDueDateCards: ->
    { modelCache } = @props

    @cancelOnUnmount(ModelLoader.loadUpNext())
      .then (response) =>
        dueDateCards = response.upNext.map (upNextItem) =>
          card = _.findWhere response.cards, id: upNextItem.data.idCard
          list = _.findWhere response.lists, id: card.idList
          board = _.findWhere response.boards, id: card.idBoard
          item = upNextItem.items[0]
          action = _.findWhere response.actions, id: item.data.idAction
          memberCreator = _.findWhere response.members, id: action?.idMemberCreator
          org = _.findWhere response.organizations, id: board.idOrganization

          action?.memberCreator = memberCreator
          board.organization = org
          card.list = list
          card.board = board
          item.data = { action }
          new Card(card, modelCache: modelCache)

          return {
            id: upNextItem.id
            card: modelCache.get('Card', card.id)
            list: new List(list, modelCache: modelCache)
            board: new Board(board, modelCache: modelCache)
            org: new Organization(org, modelCache: modelCache)
            item
          }

        return dueDateCards.filter (dueDateCard) => dueDateCard.item.type == 'dueSoon'

      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e

        console.error e
        []

  render: t.renderable ->
    { orgName, orgId } = @props
    { dueDateCards } = @state

    t.div ->
      t.div -> t.text '<TeamCardsDueContainer>'
      t.div -> t.text 'orgName: ' + orgName
      t.div -> t.text 'orgId: ' + orgId
      t.tag TeamCardsDueSection, {
        dueDateCards
      }



// WEBPACK FOOTER //
// ./app/scripts/views/home/team-cards-due-container.coffee